import config from './config'
export default {
    getToken:function(){
        var authString=localStorage.getItem('asstar');
        var authData=JSON.parse(authString);
        return authData?authData.user.token:"";
    },
    post:function(url,data,success,error){
        fetch(config.apiHost+url,
        {
          method: 'POST',
          headers:{
            'Access-Token':this.getToken()
          },
          mode: 'cors',
          credentials: 'include',
          body: JSON.stringify(data),
        }
        )
        .then(response => response.json())
        .then(data => {
            success&&success(data)
        }).catch(e => {
            error&&error(e);
        });
    },
    get:function(url,success,error){
        fetch(config.apiHost+url,
        {
            method: 'GET',
            headers:{
                'Access-Token':this.getToken()
            },
            mode: 'cors',
            credentials: 'include',
        }
        )
        .then(response => response.json())
        .then(data => {
            success&&success(data)
        }).catch(e => {
            error&&error(e);
        });
    }
}